import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the window scroll to the top on every route change.
 *
 * React Router keeps the scroll position across client-side navigations, so
 * jumping to a new page (e.g. a footer link while scrolled to the bottom) would
 * otherwise land mid-page. Keyed on `pathname` only — switching the auth
 * `?tab=` query param must NOT scroll the form away.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
